import options from './user-popover.component';

export default {
    selector: 'dtUserPopover',
    options
};



// WEBPACK FOOTER //
// ./app/common/user-popover/index.js